module.exports = __webpack_public_path__ + "img/logo_youngster.20c9005d.png";